import { useState } from 'react';
import { 
  signInWithEmailAndPassword, 
  getAuth, 
  signInWithPopup, 
  GoogleAuthProvider, 
  sendPasswordResetEmail 
} from 'firebase/auth'; 
import { auth, db } from '../firebase';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // 👁️ New state for visibility
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const firebaseAuth = getAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    try {
      const userCredential = await signInWithEmailAndPassword(firebaseAuth, email, password);
      const user = userCredential.user;
      if (user) {
        const userDocRef = doc(db, "users", user.uid);
        const userDocSnap = await getDoc(userDocRef);
        if (!userDocSnap.exists() || !userDocSnap.data()?.uid) {
          await setDoc(doc(db, "users", user.uid), {
            email: user.email,
            uid: user.uid,
          }, { merge: true });
        }
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      setError("Please enter your email address above first.");
      return;
    }
    try {
      await sendPasswordResetEmail(firebaseAuth, email);
      setMessage("Reset link sent! Check your inbox.");
      setError("");
    } catch (err) {
      setError("Error: " + err.message);
    }
  };

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      if (user) {
        await setDoc(doc(db, "users", user.uid), {
          email: user.email,
          uid: user.uid,
        }, { merge: true });
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-badge">Mango Login</div>
      <h1 className="welcome-text">Welcome Back!</h1>

      <div className="login-card">
        {error && <p className="status-msg error">{error}</p>}
        {message && <p className="status-msg success">{message}</p>}

        <form onSubmit={handleLogin} className="login-form">
          <div className="input-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="input-group password-group">
            <label>Password</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"} // 👁️ Toggles type
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
              <span 
                className="password-toggle-icon" 
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "👁️‍🗨️" : "👁️"} 
              </span>
            </div>
          </div>

          <div className="form-options">
            <label className="checkbox-container">
              <input type="checkbox" />
              <span className="checkmark"></span>
              Remember me
            </label>
            <span onClick={handleForgotPassword} className="forgot-link">
              Forgot password?
            </span>
          </div>

          <button type="submit" className="main-login-btn">
            Login to Account
          </button>

          <div className="separator">
            <span>or</span>
          </div>

          <button type="button" className="google-btn" onClick={handleGoogleLogin}>
            <img 
                src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg" 
                alt="Google" 
                className="google-icon"
            />
            Sign in with Google
          </button>
        </form>
      </div>
      
      <p className="signup-footer">
        Don’t have an account? <span onClick={() => navigate('/signup')}>Create one here</span>
      </p>
    </div>
  );
};

export default Login;